import { useContext } from 'react';

import { HealthMonitorContext } from './context';

export const useHealthMonitorContext = () => useContext(HealthMonitorContext);

export { HealthMonitorContext } from './context';
export { HealthMonitorProvider } from './provider';

export default HealthMonitorContext.Consumer;
